import { DisplayedColumn } from '../models/misc/displayed-column.model';
import { FlexibleColumnLayout } from '@fundamental-ngx/core';

export type TablePersonalizationDefinition = { defaultColumns: DisplayedColumn[]; key: string }

type ColumnConfig = {
    key: string;
    checked: boolean;
    disabled: boolean;
    visibleIn: FlexibleColumnLayout[];
};

export class TablePersonalizationDefinitions {
    private static readonly FULL_SCREEN_VIEWS: FlexibleColumnLayout[] = ['OneColumnStartFullScreen', 'TwoColumnsStartExpanded', 'TwoColumnsMidExpanded'];
    private static readonly EXPANDED_VIEWS: FlexibleColumnLayout[] = ['OneColumnStartFullScreen', 'TwoColumnsStartExpanded'];

    private static createBaseColumns(): ColumnConfig[] {
        return [
            { key: 'Resource', checked: true, disabled: true, visibleIn: this.FULL_SCREEN_VIEWS },
            { key: 'Name', checked: true, disabled: false, visibleIn: this.FULL_SCREEN_VIEWS },
            { key: 'Display Name', checked: false, disabled: false, visibleIn: this.FULL_SCREEN_VIEWS },
            { key: 'Type', checked: true, disabled: false, visibleIn: this.FULL_SCREEN_VIEWS },
            { key: 'Modified On', checked: true, disabled: false, visibleIn: this.EXPANDED_VIEWS },
            { key: 'Labels', checked: true, disabled: false, visibleIn: this.EXPANDED_VIEWS },
            { key: 'Ready', checked: true, disabled: false, visibleIn: this.FULL_SCREEN_VIEWS },
            { key: 'Description', checked: false, disabled: false, visibleIn: this.EXPANDED_VIEWS },
            { key: 'Created On', checked: false, disabled: false, visibleIn: this.EXPANDED_VIEWS },
            { key: 'API Version', checked: false, disabled: false, visibleIn: this.EXPANDED_VIEWS },
            { key: 'Path', checked: false, disabled: false, visibleIn: this.EXPANDED_VIEWS },
            { key: 'Annotations', checked: false, disabled: false, visibleIn: this.EXPANDED_VIEWS }
        ];
    }

    private static createColumns(overrides: Record<string, Partial<ColumnConfig>> = {}): DisplayedColumn[] {
        return this.createBaseColumns().map(col => {
            const override = overrides[col.key] || {};
            return new DisplayedColumn({ ...col, ...override });
        });
    }

    public static ResourcesTable: TablePersonalizationDefinition = {
        key: 'resourcesTable',
        defaultColumns: this.createColumns()
    };

    public static AdvancedSearchTable: TablePersonalizationDefinition = {
        key: 'advancedSearchTable',
        defaultColumns: this.createColumns({
            'Type': { checked: false },
            'Path': { checked: true }
        })
    };

    public static Definitions: TablePersonalizationDefinition[] = [this.ResourcesTable, this.AdvancedSearchTable];
}
